import { observer } from "mobx-react-lite"
import BlockBase from "./base"
import BlockState from "pages/scheme-editor/store/block"
import BlockInfo from "./base-info"
import InputBlock from "components/controls/input-block"

const BlockConstant = observer(({ state }: { state: BlockState }) => {

  return (
    <BlockBase state={state}>
      <InputBlock sx={{ mt: 1.5 }} multiline {...state.dataProps('value')} label="Значение" placeholder="Пустое значение"/>
      <BlockInfo state={state}>
        
      </BlockInfo>
    </BlockBase>
  )
})

export default BlockConstant